import { useState } from "react";
import { US_STATES } from "@/lib/constants";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Button } from "@/components/ui/button";
import { Check, ChevronsUpDown } from "lucide-react";
import { cn } from "@/lib/utils";

// Searchable state dropdown. Stores the 2-letter code.
export function StateSelect({ value, onChange, placeholder = "Select state…", testId, allowed }) {
  const [open, setOpen] = useState(false);
  const options = allowed && allowed.length ? US_STATES.filter((s) => allowed.includes(s[0])) : US_STATES;
  const label = US_STATES.find((s) => s[0] === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" data-testid={testId}
          className="w-full justify-between font-normal">
          {label ? `${label[1]} (${label[0]})` : <span className="text-zinc-400">{placeholder}</span>}
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command>
          <CommandInput placeholder="Search state…" />
          <CommandList>
            <CommandEmpty>No state found.</CommandEmpty>
            <CommandGroup>
              {options.map(([code, name]) => (
                <CommandItem key={code} value={`${name} ${code}`}
                  onSelect={() => { onChange(code); setOpen(false); }}>
                  <Check className={cn("mr-2 h-4 w-4", value === code ? "opacity-100" : "opacity-0")} />
                  {name} ({code})
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
